import { FilterOption } from '../../../../../ui-components/lib/filter-dropdown/filter-dropdown.model';
import { TableFilterTab } from '../../../../../ui-components/lib/table/table.model';
import { Insight } from '../../../../common/models/insight.model';
import { ActionList } from '../../../../common/models/action-list.model';
import { ENDPOINTS } from '../../../../common/constants/endpoints.constants';
import {
  PARENT_TASKS_COLUMN_HEADER,
  RELATED_REQUESTS_COLUMN_HEADER,
  COLUMN_IDENTIFIERS,
} from '../../const';

export const ASSIGNED_TO_ME_INSIGHTS: Insight[] = [
  {
    label: 'my_team_details_screen_assigned_to_tab_first_insight_label',
    value: '0',
    iconName: 'inbox',
  },
  {
    label: 'my_team_details_screen_assigned_to_tab_second_insight_label',
    value: '0',
    iconName: 'info',
  },
  {
    label: 'my_team_details_screen_assigned_to_tab_third_insight_label',
    value: '0',
    iconName: 'hold',
  },
];

export const ASSIGNED_TO_ME_VIEW_DETAILS_ACTION: ActionList = {
  key: 'view_details',
  hasIcon: true,
  label: 'view_details_action_item',
  hasDivider: false,
  labelCustomStyle: '',
  hasToggle: false,
  toggleValue: false,
  isLink: true,
};

export const ASSIGNED_TO_ME_FILTER_OPTIONS: FilterOption[] = [
  {
    key: 'workflowTypes',
    label: 'assigned_to_me_filter_workflow_types_label',
    type: 'multi',
    apiUrl: ENDPOINTS.Lookup.FlowTemplates,
    placeholder: 'assigned_to_me_filter_workflow_types_placeholder',
  },
  {
    key: 'creationDate',
    label: 'assigned_to_me_filter_creation_date_label',
    type: 'dateRange',
  },
  {
    key: 'projectIds',
    label: 'vendor_invoice_page_table_filter_option_product',
    type: 'multi',
    apiUrl: ENDPOINTS.Lookup.project,
    placeholder: 'vendor_invoice_page_table_filter_option_product_placeholder',
  },
  {
    key: 'resourceType',
    label: 'filter_resources_type_label',
    type: 'resourceType',
  },
];

export const ASSIGNED_TO_ME_ON_HOLD_TABLE_FILTER_TABS: TableFilterTab[] = [
  {
    key: 'all',
    identifier: 'all',
    label: 'table_filter_tab_all_label',
    active: true,
    iconName: 'all',
  },
  {
    key: 'in_progress',
    identifier: 'inprogress',
    label: 'table_filter_tab_inprogress_label',
    active: false,
    iconName: 'inprogress',
  },
  {
    key: 'sla_exceeded',
    identifier: 'sla_exceeded',
    label: 'table_filter_tab_sla_exceeded_label',
    active: false,
    iconName: 'clock',
  },
  {
    key: 'on_hold',
    identifier: 'on_hold',
    label: 'table_filter_tab_on_hold_label',
    active: false,
    iconName: 'hold',
  },
];

export const ASSIGNED_TO_ME_ON_HOLD_COLUMNS = [
  {
    header: '',
  },
  {
    identifier: COLUMN_IDENTIFIERS.ID,
    header: 'assigned_to_me_tab_id_header_title',
    showViewIcon: true,
    isSortable: true,
    sortKey: 'request_id][type',
  },
  {
    identifier: COLUMN_IDENTIFIERS.NAME,
    header: 'assigned_to_me_tab_request_name_header_title',
    isSortable: true,
    sortKey: 'workflow_type][type',
  },
  {
    header: PARENT_TASKS_COLUMN_HEADER,
    isSortable: false,
  },
  {
    header: 'assigned_to_me_tab_creation_date_header_title',
    isSortable: true,
    sortKey: 'created_at][type',
  },
  {
    header: 'assigned_to_me_tab_creator_header_title',
    isSortable: true,
    sortKey: 'creator][type',
  },
  {
    header: 'assigned_to_me_tab_sla_header_title',
    isSortable: true,
    sortKey: 'due_date][type',
  },
  {
    header: 'remaining_time_header_title',
    isSortable: false,
  },
  {
    identifier: COLUMN_IDENTIFIERS.REQUEST_SUBJECT,
    header: 'assigned_to_me_tab_request_subject_header_title',
    isSortable: true,
    sortKey: 'request_subject][type',
  },
  {
    header: 'assigned_to_me_tab_related_project_header_title',
    isSortable: true,
    sortKey: 'related_project][type',
  },
  {
    header: 'assigned_to_me_tab_current_step_header_title',
    isSortable: true,
    sortKey: 'current_position][type',
  },
  {
    header: 'all_participated_tab_assignees_header_title',
    isSortable: true,
    sortKey: 'assignee_count][type',
  },
  {
    identifier: 'status',
    header: 'created_by_me_tab_status_header_title',
    isSortable: true,
    sortKey: 'state][type',
  },
  {
    header: RELATED_REQUESTS_COLUMN_HEADER,
    isSortable: false,
  },
  {
    header: '',
  },
];
